var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-page-content-skeleton"},[_c('page-secondary',{attrs:{"header":_vm.headerOptions}},[_c('page-content-image-skeleton'),_c('page-container-skeleton'),_c('page-container-skeleton')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }